// import store from '@/store';
// import moment from "moment";
import consts from "@/consts";
import {getMainParentRouteName} from "@/lib/lib";
import store from "@/store";
const routeParams = {
    fleet: (route, groupId) => {
        return {
            name: consts.routerNames.md.fleet.main,
            params: {
                groupId,
            },
            query: {...route.query}
        }
    },
    vision: (route, groupId) => {
        groupId = groupId || route?.params?.groupId
        return {
            name: consts.routerNames.md.vision.main,
            params: {
                groupId,
            },
            query: {...route.query}
        }
    },
    xCargo: (route) => {
        return {
            name: consts.routerNames.md.xCargo.main,
            params: {
            },
            query: {...route.query}
        }
    }
}
const defaultSetRoute = {
    md: (route, router, groupId) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.md.main) {
            if(consts.app.$isDevelopment) console.warn(consts.routerNames.md.main+' returnToParent', route);
            return false;
        }
        router.push({
            name: consts.routerNames.md.main,
            params: {
                groupId
            },
            query: {...route.query}
        })
    },
    MDFleet: (route, router, groupId) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.md.main) {
            if(consts.app.$isDevelopment) console.warn(consts.routerNames.md.main+' returnToParent', route);
            return false;
        }
        router.push(routeParams.fleet(route, groupId))
    },
    MDVision: (route, router, groupId) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.md.main) {
            if(consts.app.$isDevelopment) console.warn(consts.routerNames.md.main+' returnToParent', route);
            return false;
        }
        router.push(routeParams.vision(route, groupId))
    },
    MDXCargo: (route, router) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.md.main) {
            if(consts.app.$isDevelopment) console.warn(consts.routerNames.md.main+' MDXCargo', route);
            return false;
        }
        router.push(routeParams.xCargo(route))
    },
    MDVisionCamerasGroup: (route, router, groupId) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.md.main) {
            if(consts.app.$isDevelopment) console.warn(consts.routerNames.md.main+' returnToParent', route);
            return false;
        }

        let localeStorageKey = store.getters.getUserStorageKey + '.MDVisionCamerasGroup'
        localStorage.setItem(localeStorageKey, groupId)

        router.push({
            name: consts.routerNames?.md?.vision?.main,
            params: {
                groupId,
            },
            query: {...route.query}
        })
    },
    unitsWidget: (route, router, widget) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.md.main) {
            if(consts.app.$isDevelopment) console.warn(consts.routerNames.md.main+' returnToParent', route);
            return false;
        }
        let groupId = route.params.groupId
        router.push({
            name: consts.routerNames.md.fleet.widget,
            params: {
                widget,
                groupId,
            },
            query: {...route.query}
        })
    },
    groupFilter: (route, router, filter) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.md.main) {
            if (consts.app.$isDevelopment) console.warn('groupFilter', route);
            return false
        }
        router.push({
            name: route.name,
            params: {
                ...route.params
            },
            query: {...filter}
        })
    }
}

const routes = (process.env.VUE_APP_PACKAGE !== 'intuit.portal') ? [] : [
    {
        path: 'md/:pathMatch(.*)?',
        name: consts.routerNames.md.main,
        redirect: {
            name: consts.routerNames.md.fleet.main,
        },
        meta: {
            mainRouteName: consts.routerNames.md.main,
            pageClass: 'unit-md-page',
            layers: consts.defaultSettingsLayers,
            routeParams,
            setRoute: defaultSetRoute,
        },
        component: () => import('@/views/intuit/portal/MdPage.vue'),
        children: [
            {
                path: 'fleet/:groupId(\\d+)?',
                name: consts.routerNames.md.fleet.main,
                meta: {
                    mainRouteName: consts.routerNames.md.main,
                    parentRouteName: consts.routerNames.md.main,
                },
                props: () => ({
                    excludeWidgets: ['fuel', 'traffic'],
                }),
                component: () => import('@/components/units/info/MD/UnitsInfo_md.vue'),
                children: [
                    {
                        path: ':widget(moving|parking|idling|traffic|fuel|mileage|offline|violations)',
                        name: consts.routerNames.md.fleet.widget,
                        meta:{
                            pageClass: 'unit-md-page unit-md-page__full',
                            mainRouteName: consts.routerNames.md.main,
                            parentRouteName: consts.routerNames.md.fleet.main,
                        },
                    }
                ]
            },
            {
                path: 'vision',
                name: consts.routerNames.md.vision.main,
                meta: {
                    list: 'GroupsList_md',
                    mainRouteName: consts.routerNames.md.main,
                    parentRouteName: consts.routerNames.md.main,
                },
                props: {
                    default: (route) => ({
                        groupId: route?.params?.groupId
                    })
                },
                components: {
                    default: () => import("@/components/md/vision/MDVision.vue")
                },
                children: [
                    {
                        path: ':groupId(\\d+)',
                        name: consts.routerNames.md.vision.groupId.main,
                        meta: {
                            mainRouteName: consts.routerNames.md.main,
                            parentRouteName: consts.routerNames.md.vision.main,
                        },
                    },
                ]
            },
            {
                path: 'xCargo',
                name: consts.routerNames.md.xCargo.main,
                meta: {
                    mainRouteName: consts.routerNames.md.main,
                    parentRouteName: consts.routerNames.md.main,
                },
                props: {
                },
                components: {
                    default: () => import("@/components/md/xCargo/MDXCargo.vue")
                },
                children: [
                ]
            },
        ]
    },
];

export default routes;